// routes.js
import HomePage from './HomePage'; // 确保路径正确
import Verify from './Verify'; // 确保路径正确
import Success from './Success'; // 确保路径正确
// import NotFound from './NotFound'; // 确保路径正确

// 路由配置
const routes = [
  { path: '/', element: <HomePage /> },
  { path: '/verify', element: <Verify /> },
  { path: '/success', element: <Success /> },
//   { path: '*', element: <NotFound /> }, // 捕获所有未定义的路径
];

export default routes;